import React from 'react';
import { Chevron, chevronSideBearing, STRIP_ICON_BUTTON_CLASS, STRIP_ICON_CLASS } from '@charitystack/shared';

// The visible stroke of the Back chevron sits on the strip's inset, so it lines up with the
// left edge of the fields below: the button's 2 padding plus the chevron's empty left side.
const BACK_PULL_IN = `calc(-1 * (var(--cs-space-hairline) + ${chevronSideBearing('var(--cs-icon-lg)')}))`;

/**
 * The 52 title strip at the top of a form card (Paper 2JU-0): every step names itself here,
 * so the start page, the questions step and the schedule step share one header. The mobile
 * drawer has its own strip, so callers skip this inside it.
 *
 * `onBack` puts the step's Back at the strip's left edge (owner call 2026-10-21): the shared
 * strip icon button, tightened to a 24 square (the glyph plus 2 a side) with the compact
 * corner, so its hover fill hugs the chevron and never reaches the title with the shared 20 chevron, the chevron's visible stroke on the strip's 20 inset (aligned with the fields below) and a 2
 * gap before the title. Steps
 * after the first pass it here instead of drawing a Back under their primary button.
 */
export default function FormTitleStrip({ id, children, onBack, backId, backDisabled = false }) {
  return (
    <div className="cs-form-title-strip" id={id}>
      {onBack && (
        <button
          type="button"
          aria-label="Back"
          id={backId}
          onClick={onBack}
          disabled={backDisabled}
          // cs-allow-hardcoded: an optical offset derived from the icon token and the chevron's
          // own geometry (chevronSideBearing), not a spacing value.
          style={{ marginInlineStart: BACK_PULL_IN }}
          className={`${STRIP_ICON_BUTTON_CLASS} !w-auto !h-auto p-[var(--cs-space-hairline)] me-[var(--cs-space-hairline)] !rounded-[var(--cs-icon-button-compact-radius)] disabled:cursor-not-allowed disabled:opacity-[var(--cs-opacity-disabled)]`}
        >
          <Chevron direction="left" className={STRIP_ICON_CLASS} />
        </button>
      )}
      {children}
    </div>
  );
}
